import React from "react";
import { connect } from "react-redux";

import { Link, useMatch } from "../../utils/components/router";

export const Address = connect(store => {
  return {
    configStorage: store.configStorage
  };
})((props) => {
  let { configStorage, kunde, doShip, selectedFiliale, isEditable } = props || {};
  const { params } = useMatch() || {};
  const adresseId = params ? params.id : null;

  let listKundenAdressen = kunde ? kunde.listKundenAdressen : null;
  if (listKundenAdressen === null) {
    return <span>Loading</span>;
  } else if (doShip === "no" && selectedFiliale) {
    return (
      <React.Fragment>
        <div>{(
           !selectedFiliale.name ? selectedFiliale.address : selectedFiliale.name)}
        </div>
      </React.Fragment>
    );
  } else if (Array.isArray(listKundenAdressen)) {
    let kundenAdresse = listKundenAdressen.find(
      x => String(x.id) === String(adresseId)
    );
    if (!kundenAdresse) {
      kundenAdresse = {
        name: "",
        strasse: kunde.strasse1,
        strasse2: kunde.strasse2,
        plz: kunde.plz,
        ort: kunde.ort
      };
    }
    return (
      <React.Fragment>
        <div>{kunde.vorname ? kunde.vorname + " " + kunde.nachname : kunde.nachname}</div>
        <div>{kundenAdresse.name}</div>
        <div>{kundenAdresse.strasse}</div>
        {kundenAdresse.strasse2
          ? <div>{kundenAdresse.strasse2}</div>
          : null}
        <div>
          {kundenAdresse.plz}{" "}
          {kundenAdresse.ort}
        </div>
        <p>Deutschland</p>
        {isEditable
          ?
          <Link
            to={configStorage.getLinkPath("LINK_KUNDEN_ADDRESSE_MA", kunde.id)}
            className="btn btn-primary"
          >
            ändern
          </Link>
          : null
        }
      </React.Fragment>
    );
  }
});
